import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
} from '@/components/ui/alert-dialog'

interface DeleteExceptionDialogProps {
    isOpen: boolean
    onClose: () => void
    onDelete: () => void
    exceptionIndex?: number
}

export function DeleteExceptionDialog({
    isOpen,
    onClose,
    onDelete,
    exceptionIndex
}: DeleteExceptionDialogProps) {
    return (
        <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Exception löschen?</AlertDialogTitle>
                    <AlertDialogDescription>
                        Möchten Sie die Exception {exceptionIndex !== undefined && `${exceptionIndex + 1}`} wirklich löschen?
                        Alle zugehörigen Weiterleitungsziele werden ebenfalls gelöscht.
                        Diese Aktion kann nicht rückgängig gemacht werden.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={onClose}>Abbrechen</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={onDelete}
                        className="bg-red-500 hover:bg-red-600"
                    >
                        Löschen
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}
